"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _classnames = _interopRequireDefault(require("classnames"));
var eventHandlerUtils = _interopRequireWildcard(require("../../utils/eventHandlers"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowDownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "button": "button_1EgIk0",
  "dropdown-button": "dropdown-button_3K9gvc",
  "dropdownButton": "dropdown-button_3K9gvc",
  "borderless-button": "borderless-button_1wuUS2",
  "borderlessButton": "borderless-button_1wuUS2",
  "dropdown-container": "dropdown-container_1OqNhP",
  "dropdownContainer": "dropdown-container_1OqNhP",
  "dropdown-header": "dropdown-header_2fh0o6",
  "dropdownHeader": "dropdown-header_2fh0o6",
  "dropdown-body": "dropdown-body_daQlth",
  "dropdownBody": "dropdown-body_daQlth",
  "ul": "ul_13aPXH",
  "hr": "hr_XN2vUA",
  "li": "li_2OmInt",
  "checked-checkbox": "checked-checkbox_13bTjh",
  "checkedCheckbox": "checked-checkbox_13bTjh",
  "all-option": "all-option_20th0R",
  "allOption": "all-option_20th0R",
  "checkbox-label": "checkbox-label_2-vc9Y",
  "checkboxLabel": "checkbox-label_2-vc9Y",
  "dropdown-footer": "dropdown-footer_1R_7Ga",
  "dropdownFooter": "dropdown-footer_1R_7Ga",
  "arrow-icon": "arrow-icon_19lTPf",
  "arrowIcon": "arrow-icon_19lTPf",
  "expanded": "expanded_2iwzRf"
}; 
require('./MultipleSelector.css');
var getOptionIndeterminate = function getOptionIndeterminate(options) {
  return !options.every(function (_ref) {
    var checked = _ref.checked;
    return checked;
  }) && options.some(function (_ref2) {
    var checked = _ref2.checked;
    return checked;
  });
};
var hasDifferentKeys = function hasDifferentKeys(currentKeys, previousKeys) {
  return currentKeys.length !== previousKeys.length || currentKeys.some(function (displayedKey) {
    return !previousKeys.find(function (key) {
      return key === displayedKey;
    });
  });
};
var buildDisplayedOptions = function buildDisplayedOptions(options, keys, searchTerm) {
  return options.filter(function (option) {
    return !searchTerm || option.label.toLowerCase().includes(searchTerm.trim().toLowerCase());
  }).map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      checked: keys.includes(option.key)
    });
  });
};
var MultipleSelector = function MultipleSelector(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(props.selectedKeys),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    displayedSelectedKeys = _useState4[0],
    setDisplayedSelectedKeys = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    searchTerm = _useState6[0],
    setSearchTerm = _useState6[1];
  var displayedOptions = (0, _react.useMemo)(function () {
    return buildDisplayedOptions(props.options, displayedSelectedKeys, searchTerm);
  }, [props.options, displayedSelectedKeys, searchTerm]);
  var handleCheckBoxChange = (0, _react.useCallback)(function (key, checked, isAll) {
    var hasKeysSelected = displayedSelectedKeys.length;
    if (isAll) {
      if (hasKeysSelected) {
        // Deletes all elements from selected keys
        setDisplayedSelectedKeys([]);
      } else {
        // Adds all elements from selected keys
        setDisplayedSelectedKeys(props.options.map(function (option) {
          return option.key;
        }));
      }
    } else if (checked) {
      // Adds new element to selected keys
      setDisplayedSelectedKeys(displayedSelectedKeys.concat(key));
    } else {
      // Deletes unchecked element from selected keys
      setDisplayedSelectedKeys(displayedSelectedKeys.filter(function (selectedKey) {
        return selectedKey !== key;
      }));
    }
  }, [displayedSelectedKeys, props.options]);
  var buildHandleLabel = (0, _react.useCallback)(function (option) {
    return function () {
      return handleCheckBoxChange(option.key, !option.checked, option.isAllOption);
    };
  }, [handleCheckBoxChange]);
  var label = (0, _react.useMemo)(function () {
    var selectedKeysLength = displayedSelectedKeys.length;
    if (!selectedKeysLength) {
      return "No ".concat(props.optionNameSingular, " selected");
    }
    if (selectedKeysLength === 1) {
      var _optionFinded$label;
      var optionFinded = props.options.find(function (option) {
        return option.key === displayedSelectedKeys[0];
      });
      return (_optionFinded$label = optionFinded === null || optionFinded === void 0 ? void 0 : optionFinded.label) !== null && _optionFinded$label !== void 0 ? _optionFinded$label : displayedSelectedKeys[0];
    }
    if (selectedKeysLength === props.options.length) {
      return "".concat(props.allOptionPrefix, " ").concat(props.optionNamePlural);
    }
    return "".concat(displayedSelectedKeys.length, " ").concat(props.optionNamePlural);
  }, [displayedSelectedKeys, props.allOptionPrefix, props.optionNameSingular, props.optionNamePlural]);
  var changeSearch = (0, _react.useCallback)(function (event) {
    setSearchTerm(event.value);
  }, []);
  var handleToggle = (0, _react.useCallback)(function () {
    setIsExpanded(!isExpanded);
    setSearchTerm('');
    if (isExpanded && hasDifferentKeys(displayedSelectedKeys, props.selectedKeys)) {
      if (displayedSelectedKeys.length) {
        // If there are selected options apply the change
        props.onSelectedKeysChange(displayedSelectedKeys);
      } else {
        // If there is no selected options go to the initial state
        setDisplayedSelectedKeys(props.selectedKeys);
      }
    }
  }, [isExpanded, displayedSelectedKeys, props]);
  var handleBlur = (0, _react.useCallback)(function (event) {
    if (isExpanded && !event.currentTarget.contains(event.relatedTarget)) {
      handleToggle();
    }
  }, [isExpanded, handleToggle]);
  var renderOptions = (0, _react.useCallback)(function () {
    var mapToOption = function mapToOption(option) {
      var isIndeterminate = option.isAllOption && getOptionIndeterminate(displayedOptions);
      var handleLabel = buildHandleLabel(option);
      return /*#__PURE__*/_react.default.createElement("li", {
        className: (0, _classnames.default)(styles.li, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.allOption, option.isAllOption), styles.checkedCheckbox, option.checked || isIndeterminate)),
        "data-test-id": "option-".concat(option.key),
        key: option.key,
        role: "option",
        "aria-selected": option.checked
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        tabindex: -1,
        checked: option.checked,
        indeterminate: isIndeterminate,
        onChange: function onChange(event) {
          return handleCheckBoxChange(option.key, event.value, option.isAllOption);
        }
      }), /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "label-".concat(option.key),
        key: "label-".concat(option.key),
        className: styles.checkboxLabel,
        role: "button",
        tabIndex: 0,
        onKeyDown: eventHandlerUtils.onEnterKey(handleLabel),
        title: option.label,
        onClick: handleLabel
      }, option.label));
    };
    var options = displayedOptions.map(mapToOption);
    if (props.showSelectAllOptions && !searchTerm.trim()) {
      return [mapToOption({
        label: "".concat(props.allOptionPrefix, " ").concat(props.optionNamePlural),
        key: 'all',
        checked: displayedOptions.every(function (_ref3) {
          var checked = _ref3.checked;
          return checked;
        }),
        isAllOption: true
      }), /*#__PURE__*/_react.default.createElement("hr", {
        className: styles.hr
      })].concat((0, _toConsumableArray2.default)(options));
    }
    return options;
  }, [displayedOptions, searchTerm, props.allOptionPrefix, props.showSelectAllOptions, props.optionNamePlural]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: props.id,
    "data-test-id": props.id,
    tabIndex: -1,
    role: "combobox",
    onBlur: handleBlur,
    "aria-label": props.id,
    "aria-expanded": isExpanded,
    "aria-controls": "".concat(props.id, "-expanded-list")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "".concat(props.id, "-open-dropdown"),
    className: (0, _classnames.default)(styles.button, styles.dropdownButton, styles.borderlessButton),
    kind: "tertiary",
    noFill: true,
    onClick: handleToggle
  }, label, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    isDecorative: true,
    size: "xs",
    className: (0, _classnames.default)(styles.arrowIcon, (0, _defineProperty2.default)({}, styles.expanded, isExpanded))
  }, /*#__PURE__*/_react.default.createElement(ArrowDownIcon, null))), isExpanded ? /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "dropdown-container",
    className: styles.dropdownContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "dropdown-header",
    className: styles.dropdownHeader
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "search",
    placeholder: "Search",
    size: "md",
    onChange: changeSearch,
    value: searchTerm,
    testId: "".concat(props.id, "-search-box-text-field")
  })), displayedOptions.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownBody,
    "data-test-id": "dropdown-body"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    id: "".concat(props.id, "-expanded-list"),
    className: styles.ul,
    "data-test-id": "option-list",
    tabIndex: -1,
    role: "listbox"
  }, renderOptions())) : null, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "dropdown-footer",
    className: styles.dropdownFooter
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "apply-button",
    kind: "secondary",
    onClick: handleToggle,
    disabled: !displayedSelectedKeys.length
  }, "Apply"))) : null);
};
MultipleSelector.defaultProps = {
  allOptionPrefix: 'All',
  id: 'multiple-selector'
};
var _default = exports.default = MultipleSelector;
//# sourceMappingURL=MultipleSelector.js.map